import { validationConstants } from "../constants";

const initialState = {
  loading: false,
  error: null,
  items: null,
};

export const SetDocValidationData = (state = initialState, action) => {
  switch (action.type) {
    case validationConstants.SET_DOC_VALIDATION_REQUEST:
      return {
        ...state,
        loading: true,
        items: null,
        error: null,
      };

    case validationConstants.SET_DOC_VALIDATION_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload,
        error: null,
      };

    case validationConstants.SET_DOC_VALIDATION_FAILURE:
      return {
        ...state,
        loading: false,
        items: null,
        error: action.payload,
      };
    default:
      return state;
  }
};